import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { Modal } from '../common/Modal';
import restClient from '../../api/rest-client';

const MotdBanner: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [acknowledging, setAcknowledging] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const checkStatus = async () => {
      try {
        const status = await restClient.getMotdStatus();
        if (cancelled) return;

        if (status.needs_acknowledgment) {
          const motd = await restClient.getMotd();
          if (cancelled) return;
          setMessage(motd.message);
          setShowModal(true);
        }
      } catch {
        // Silently fail — don't block the user experience
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    checkStatus();
    return () => { cancelled = true; };
  }, []);

  const handleAcknowledge = async () => {
    setAcknowledging(true);
    try {
      await restClient.acknowledgeMotd();
      setShowModal(false);
    } catch {
      // Silently fail — user can try again
    } finally {
      setAcknowledging(false);
    }
  };

  if (loading || !showModal) return null;

  return (
    <Modal
      isOpen={showModal}
      onClose={handleAcknowledge}
      title="Message of the Day"
      className="sm:max-w-lg"
      showCloseButton={false}
    >
      <div
        className="overflow-y-auto max-h-[60vh] text-base break-words text-gray-800 motd-markdown"
      >
        <ReactMarkdown
          components={{
            a: ({ ...props }) => (
              <a {...props} target="_blank" rel="noopener noreferrer" className="text-primary-600 underline hover:text-primary-800 break-all" />
            ),
          }}
        >
          {message}
        </ReactMarkdown>
      </div>
      <div className="mt-6 flex justify-end">
        <button
          onClick={handleAcknowledge}
          disabled={acknowledging}
          className="min-w-[44px] min-h-[44px] px-6 py-3 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {acknowledging ? 'Acknowledging...' : 'Got it'}
        </button>
      </div>
    </Modal>
  );
};

export default MotdBanner;
